import Accordion, { AccordionContent, AccordionItem, AccordionTrigger } from '@cobliteam/ui/components/Accordion';
import Tag from '@cobliteam/ui/components/Tag';
import Typography from '@cobliteam/ui/components/Typography';
import Icon from '@cobliteam/ui/icons';
import { memo } from 'react';

interface CategoryAccordionProps {
  title: string;
  description: string;
  children: React.ReactNode;
  totalSteps: number;
  checkedSteps: number;
}

const CategoryAccordion = ({ title, description, children, totalSteps, checkedSteps }: CategoryAccordionProps) => {
  return (
    <Accordion type='single' collapsible defaultValue={checkedSteps !== totalSteps ? `category-${title}` : undefined}>
      <AccordionItem value={`category-${title}`}>
        <AccordionTrigger>
          <div className='flex flex-col gap-2'>
            <div className='flex flex-row items-center gap-2'>
              <Typography variant='text-lg-semibold'>{title}</Typography>
              {checkedSteps !== totalSteps ? (
                <Tag variant='outlined' color='primary' size='condensed' label={`${checkedSteps}/${totalSteps}`} />
              ) : (
                <Icon name='check' color='primary' />
              )}
            </div>
            <Typography variant='text-md' color='secondary'>
              {description}
            </Typography>
          </div>
        </AccordionTrigger>
        <AccordionContent className='flex flex-col gap-4'>{children}</AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};

export default memo(CategoryAccordion);
